import str_plural from '@src/helpers/str_plural';
import {IPermissionsNamesResolver} from '@src/@interfaces/services/NameResolvers/IPermissionsNamesResolver';
import {snake_case} from '@src/helpers/string-registres';

export default class PermissionsNamesResolver implements IPermissionsNamesResolver {
    static INDEX_ROUTE_PERMISSION_NAME = 'index';
    static IMPORT_ROUTE_PERMISSION_NAME = 'import';
    static SHOW_ROUTE_PERMISSION_NAME = 'show';
    static UPDATE_ROUTE_PERMISSION_NAME = 'update';
    static CREATE_ROUTE_PERMISSION_NAME = 'store';
    static DELETE_ROUTE_PERMISSION_NAME = 'destroy';
    static RESTORE_ROUTE_PERMISSION_NAME = 'restore';
    static UPDATE_ORDER_NUMBER_ROUTE_PERMISSION_NAME = 'sort';

    getIndexRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'INDEX_ROUTE_PERMISSION_NAME');
    }

    getImportRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'IMPORT_ROUTE_PERMISSION_NAME');
    }

    getShowRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'SHOW_ROUTE_PERMISSION_NAME');
    }

    getCreateRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'CREATE_ROUTE_PERMISSION_NAME');
    }

    getUpdateRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'UPDATE_ROUTE_PERMISSION_NAME');
    }

    getDeleteRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'DELETE_ROUTE_PERMISSION_NAME');
    }

    getRestoreRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'RESTORE_ROUTE_PERMISSION_NAME');
    }

    getUpdateRecordsOrderNumberRoutePermissionName(modelName: string): string {
        return this.resolve(modelName, 'UPDATE_ORDER_NUMBER_ROUTE_PERMISSION_NAME');
    }

    protected resolve(modelName: string, constantName: keyof typeof PermissionsNamesResolver): string {
        return snake_case(str_plural(modelName), '-') + '@' + PermissionsNamesResolver[constantName];
    }
}
